@if (isLoading) {
  <div class="loading">
    <app-loading></app-loading>
  </div>
}

@if (!isLoading) {
  <div class="user-topics">
    @if (userTopics.length <= 0) {
      <div class="topics-status">The posts has not yet been created</div>
    }
    @for (topic of userTopics; track topic; let i = $index) {
      <app-forum-topic-title [theme]="theme" [hasLine]="i < userTopics.length - 1" [topic]="topic">
      </app-forum-topic-title>
    }
    <app-pagination
      [theme]="theme"
      [pageIndex]="page.number"
      [length]="page.totalItems"
      [pageSize]="page.size"
      (page)="changePage($event)"
    ></app-pagination>
  </div>
}
